// JavaScript source code
import React from "react";
import Nav from "../components/Nav";
import Contacts from "../components/Contact";



function Contact() {
    return (
        <div>
            <Nav />
            <Contacts />
        </div>
    );
}

export default Contact;
